export default __webpack_public_path__ + "static/Picker-Wheel-b87e4fd9e4cbb4576fc7187ac88134ca.png";